// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBWBCyi7moXGQ9S-nyBMofaFXd-F1oyn_g",
  authDomain: "ascennd-tours.firebaseapp.com",
  projectId: "ascennd-tours",
  storageBucket: "ascennd-tours.firebasestorage.app",
  messagingSenderId: "1089230735680",
  appId: "1:1089230735680:web:d15546bce64f0b915f12a5",
  measurementId: "G-BVYQDD1WTZ"
};

const app = initializeApp(firebaseConfig);

export const storage = getStorage(app);
export const db = getFirestore(app);
